export enum DEVICE_REQUEST_ID_LIST {
  POST_DEVICE_LIST = 'POST_DEVICE_LIST',
  POST_FORCE_LOGOUT = 'POST_FORCE_LOGOUT',
  CALL_DEVICE_LIST_TNC = 'CALL_DEVICE_LIST_TNC',
}

export enum DEVICE_TRANSLATION_KEY {
  DEVICE_LOGOUT_IS_INVALID = 'device.logout.isInvalid',
}
